import { render, staticRenderFns } from "./PasswordResetComponent.vue?vue&type=template&id=05d2d349&scoped=true&"
import script from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetComponent.vue?vue&type=style&index=0&id=05d2d349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2d349",
  null
  
)

export default component.exports